import classes from "./Checkout.module.scss";
// import OrderItem from "./OrderItem/OrderItem";

const Checkout = () => {
  return (
    <div className={classes.Checkout}>
      <h3>Order ID #42354432 </h3>
      <div className={classes.OrderInfo}>
        <p>John Doe</p>
        <p>Dine-In T-32 </p>
      </div>
      <div className={classes.OrderItems}>
        {/* <OrderItem
          key={Math.random(100)}
          id={index + 1}
          name={item.item_name}
          quantity={item.quantity}
          price={item.price}
          onRemove={removeDishFromCart}
          onReduceItemQuantity={onReduceItemQuantity}
          onIncreaseItemQuantity={onIncreaseItemQuantity}
        /> */}
      </div>
    </div>
  );
};

export default Checkout;
